export type TUserMachineRole = 'dealer' | 'owner' | 'operator';

export const UserMachineRole: Record<string, TUserMachineRole> = {
    DEALER: 'dealer',
    OWNER: 'owner',
    OPERATOR: 'operator',
};